import { Accordion } from 'react-bootstrap'
import '../styles/PreguntasFrecuentes.css'

const PreguntasFrecuentes = ({preguntas}) => {

    const onChangeCalificacion = (e, id) => {

        if (e.target.value === 'si') {
            document.getElementById('util_si_' + id).src = '/assets/img/homeout/Mano_seleccionada_arriba.png'
            document.getElementById('util_no_' + id).src = '/assets/img/homeout/Mano_gruis_abajo.png'
        }
        else {
            document.getElementById('util_si_' + id).src = '/assets/img/homeout/Mano_gruis_arriba.png'
            document.getElementById('util_no_' + id).src = '/assets/img/homeout/Mano_seleccionada_abajo.png'
        }

    }

    return (
        <>
            <div className="homeout__preguntas" id="faq">
                <h1 className='titulo_preguntas'>Preguntas frecuentes</h1>
                <div className="container"> 
                    <div className="preguntas__group">
                        <Accordion className='accordion__faq' flush>
                            {
                                preguntas && (
                                    preguntas.map((pregunta,index) => {
                                        return (
                                            <Accordion.Item eventKey={String(index)} key={index+'-acordion'}>
                                                <Accordion.Header >
                                                    <div className='pregunta__titulo d-none d-lg-block'>
                                                        <h4 style={{ fontSize:'20px', textAlign:"left", fontWeight:'bold'}} >{pregunta.pregunta}</h4>
                                                    </div>
                                                    <div className='pregunta__titulo d-block d-lg-none  '>
                                                        <h4 >{pregunta.pregunta}</h4>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className='pregunta__detalle '>
                                                        <p style={{ textAlign: 'left' }} className='body__respuesta mb-3 mt-0 ' dangerouslySetInnerHTML={{__html: pregunta.respuesta}}></p><br/>
                                                        <p style={{ textAlign: 'left',fontWeight:'bold' }}>
                                                            <label style={{ marginRight: '2rem' }}>¿Resultó útil esta información?</label>
                                                            <div className="d-lg-none"></div>
                                                            <input className="radio__calificacion" value="si" type="radio" name="util_info" id={"pulgar_si_" + pregunta.id} onChange={(e) => onChangeCalificacion(e, pregunta.id)} />
                                                            <label htmlFor={"pulgar_si_" + pregunta.id}>
                                                                <img src="/assets/img/homeout/Mano_gruis_arriba.png" id={"util_si_" + pregunta.id} alt=""></img>
                                                            </label>
                                                            <input className="radio__calificacion" value="no" type="radio" name="util_info" id={"pulgar_no_" + pregunta.id} onChange={(e) => onChangeCalificacion(e, pregunta.id)} />
                                                            <label htmlFor={"pulgar_no_" + pregunta.id}>
                                                                <img src="/assets/img/homeout/Mano_gruis_abajo.png" id={"util_no_" + pregunta.id} alt=""></img>
                                                            </label>
                                                        </p>
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        )
                                    })
                                )
                            }
                        </Accordion>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PreguntasFrecuentes